export const CONTENT_TYPES = {
  HOUSEHOLD: 'cleaningProductData',
  PROFESSIONAL: 'b2bCleaningProductData',
  BLOG_POST: 'blogPost'
};

export const ROUTE_TO_CONTENT_TYPE = {
  'household': CONTENT_TYPES.HOUSEHOLD,
  'professional': CONTENT_TYPES.PROFESSIONAL
};

export const PRODUCT_TITLES = {
  'household': 'Household Products',
  'professional': 'Professional Solutions'
};

export const PRODUCT_SECTIONS = {
  'household': {
    showComparison: true,
    showTestimonials: true,
    showQuoteButton: false
  },
  'professional': {
    showComparison: false,
    showTestimonials: false,
    showQuoteButton: false
  }
}; 